'use client'

import { APOLLO_CLIENT_SIDE_OPTIONS } from '@/lib/apollo/clients/apolloClient.client'
import { useIsAuthenticated } from '@/lib/auth/client/AuthProvider.client'
import { useQuery } from '@apollo/client'
import { gql } from '@gql-generated/gql'
import { UseCartIdDocument } from '@gql-generated/graphql'

gql(/* GraphQL */ `
  query UseCartId {
    currentUser {
      id
      checkout {
        cart(forceRefresh: false) {
          id
        }
      }
    }
  }
`)

export function useCartId(): string | undefined {
  const isAuthenticated = useIsAuthenticated()

  const { data } = useQuery(UseCartIdDocument, {
    ...APOLLO_CLIENT_SIDE_OPTIONS,
    skip: !isAuthenticated,
  })

  return data?.currentUser?.checkout?.cart?.id
}
